// extracted by mini-css-extract-plugin
module.exports = {"container":"MCSelector_container__25EDr","option":"MCSelector_option__3_vRg","selected":"MCSelector_selected__3rkGZ","answer":"MCSelector_answer__1CBxK"};